import { cloneDeep, merge } from 'lodash'

import { proxy } from '@/utils'

import { core } from '@/components/services/settingsSite/utils'

import render from './render'

const defaultValue = {
  key: undefined,
  value: undefined
}

export default function(options) {
  return {
    mixins: [ proxy({ type: 'object' }), core(options) ],

    computed: {
      validation() {
        return this.proxy.every(item => {
          return Boolean(item.key && item.value)
        })
      }
    },

    methods: {
      add() {
        this.proxy.push(cloneDeep(defaultValue))
      },
      remove(index) {
        this.proxy.splice(index, 1)
        if (this.proxy.length === 0) {
          this.add()
        }
      },

      _inputFilter(value) {
        if (Object.keys(value).length === 0) {
          return [ cloneDeep(defaultValue) ]
        }

        return Object.keys(value).reduce((result, key) => {
          result.push({
            key,
            value: value[key]
          })

          return result
        }, [])
      },
      _outputFilter(value) {
        return value.reduce((result, element) => {
          if (element.key && element.value) {
            merge(result, { [element.key]: element.value })
          }

          return result
        }, options.defaults[options.path])
      }
    },

    render(h) {
      return render.call(this, h, options)
    }
  }
}
